<template></template>

<script>
// ************* 此為舊的進入友圈方式，可以不用維護此檔，目前進入點直接從 App.vue 進入。 2021/01/22 **************
// ************* 因為以前以為 APP 的按鈕不允許 url 帶有 # ，因為 vue 採用 hash 模式， url 會有 #，所以才使用靜態網頁做導轉
// ************* 不過雖然在 APP 下方的五個 tab 鍵可允許 #，但若將含有 # 的連結放在聊天室裡去點擊還是會壞掉，需要注意此特性

// 此頁面專門提供給 "開發時" 的動態取得 token 並存入 session 後導轉到貼文牆
// build 出來後的環境請使用 public\login.html 的方法

// 以下請替換自己開發環境的 ip
// 主頁貼文牆: http://192.168.5.110:8080/#/login?target=postWall&token={token}
// 我的貼文牆: http://192.168.5.110:8080/#/login?target=myPost&token={token}
// 某位朋友的貼文牆: http://192.168.5.110:8080/#/login?target=friendPost&fid=@limeng.chen:lalepass.lale.im&token={token}
// 相簿: http://192.168.5.110:8080/#/login?target=album&token={token}

import axios from 'axios';
import { mapActions } from 'vuex';
export default {
  name: 'Login',
  created() {
    this.goGawbuePostWall();
  },
  methods: {
    ...mapActions(['getApiUserInfo']),
    goGawbuePostWall(context) {
      // 取得開發環境 domain ip
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      // 取得要導到哪一個頁面
      let target = location.href.slice(location.href.indexOf('target=') + 7, location.href.indexOf('&token='));
      if (location.href.indexOf('fid=') > -1) {
        target = location.href.slice(location.href.indexOf('target=') + 7, location.href.indexOf('&fid='));
      }
      // 取得朋友的 user ID(從朋友名片進入的友圈)
      const fid = location.href.slice(location.href.indexOf('&fid=') + 5, location.href.indexOf('&token='));
      // 取得 Lale token
      const laleToken = location.href.slice(location.href.indexOf('token=') + 6);
      // 將重要資訊存入 localStorage
      localStorage.setItem('domain', baseUrl);
      localStorage.setItem('laleToken', laleToken);

      console.log(baseUrl);
      console.log(laleToken);

      // 判斷裝置
      const myUserAgent = navigator.userAgent;
      let isiOS = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      const mobileType = isiOS ? 'ios' : 'android';

      // 撈取所有對自己設為公開的貼文
      let api = `${process.env.VUE_APP_API_PATH}/gawbue/${laleToken}`;
      if (target === 'myPost') {
        // 我的主頁:只撈取自己貼文的資料
        api = `${baseUrl}/gawbuebyme/${laleToken}/${mobileType}`;
      } else if (target === 'friendPost') {
        // 朋友的主頁:只撈取該名朋友的貼文資料
        api = `${baseUrl}/gawbue/${fid}/${laleToken}`;
      }
      axios
        .get(api)
        .then(res => {
          console.log('token 存入 session');
          this.getApiUserInfo();

          if (target === 'album') {
            // 導轉到相簿
            window.location.replace(`${baseUrl}/#/album`);
          } else if (target === 'myPost') {
            // 導轉到我自己的貼文牆
            window.location.replace(`${baseUrl}/#/myPost`);
          } else if (target === 'friendPost') {
            // 導轉到朋友的貼文牆
            window.location.replace(`${baseUrl}/#/friendPost/${fid}`);
          } else {
            // 導轉到貼文牆
            window.location.replace(`${baseUrl}/#/postWall`);
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<style></style>
